module.exports = __webpack_public_path__ + "static/media/konstuniversitetetUniversityofArts.7529f4b5.webp";